import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ConnectedRouter } from 'connected-react-router';
import history from './utils/history';

// Add Store (Redux)
import { Provider } from 'react-redux';
import { store } from './redux/configure';
// Toster
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';
import 'react-toastify/dist/ReactToastify.css';

import './styles/base/index.css';
import './styles/base/bootstrap.css';
import './styles/base/App.css';
import './styles/base/leaflet.css';
import './assets/WebFonts/css/style.css';
// Material Ui5
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from './theme';
// RTL support
import {
  StylesProvider,
  ThemeProvider,
  jssPreset,
} from '@material-ui/core/styles';
import { create } from 'jss';
import rtl from 'jss-rtl';

// Configure JSS rtl
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
// Custom Material-UI class name generator.
ReactDOM.render(
  <StylesProvider jss={jss}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <CssBaseline />
        <ConnectedRouter history={history}>
          <Toaster
            position="top-left"
            toastOptions={{
              style: {
                width: '350px',
                color: 'white',
                background: '#ff9800',
              },
              duration: 5000,
              success: {
                style: {
                  background: '#4caf50',
                  color: 'white',
                },
              },
              error: {
                style: {
                  background: '#F30000',
                  color: 'white',
                },
              },
            }}
          />
          <ToastContainer />
          <App />
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>
  </StylesProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
